import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22ScaffopsMarketingShell.tsx%22,%22import%22:%22Big_Shoulders%22,%22arguments%22:[{%22subsets%22:[%22latin%22],%22weight%22:[%22800%22,%22900%22],%22variable%22:%22--font-sm-display%22,%22display%22:%22swap%22,%22adjustFontFallback%22:true,%22preload%22:true}],%22variableName%22:%22display%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Big Shoulders'",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
